import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function submitLead(payload) {
  const res = await axios.post(`${API}/leads`, payload, {
    headers: { "Content-Type": "application/json" },
    timeout: 15000,
  });
  return res.data;
}
